<nz-modal
  [nzWidth]="'800px'"
  [(nzVisible)]="isVisible"
  (nzVisibleChange)="onIsVisibleChange($event)"
  [nzTitle]="isEdit ? 'Edit Scenario' : 'Add New Scenario'"
  (nzOnCancel)="onCancelClick()"
>
  <ng-container *nzModalContent>
    <form nz-form [nzLayout]="'vertical'" [formGroup]="validateForm" (ngSubmit)="submitForm()">
      <nz-form-item>
        <nz-form-label nzRequired nzFor="title">Name</nz-form-label>
        <nz-form-control nzErrorTip="Title required.">
          <input nz-input formControlName="title" id="title" [placeholder]="'Scenario Name'" />
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzRequired nzFor="targetCallDuration">Target Call Duration</nz-form-label>
        <nz-form-control nzErrorTip="Duration is required.">
          <nz-input-number-group [ngStyle]="{ width: '200px' }" nzAddOnAfter="Minutes">
            <nz-input-number
              formControlName="targetCallDuration"
              [nzStep]="1"
              [nzMax]="60"
              [nzMin]="1"
            ></nz-input-number>
          </nz-input-number-group>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzFor="instruction">Instruction</nz-form-label>
        <nz-form-control nzErrorTip="Instruction required.">
          <textarea
            nz-input
            formControlName="instruction"
            rows="5"
            id="instruction"
            [placeholder]="instructionPlaceholder"
          ></textarea>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label>
          <div class="horizontal">
            <div>Soft-skills Objections & Questions</div>
            <a nz-button nzType="default" nzSize="small" (click)="onEditSoftSkillsObjectionClick()">
              <span nz-icon style="font-size: 16px" class="material-symbols-rounded">edit</span>
            </a>
          </div>
        </nz-form-label>
        <nz-form-control>
          <div class="vertical">
            @for (emotionalId of sessionTemplate?.unsafeSubData?.emotionalObjectionIdList ?? []; track $index) {
              <div>- {{ getObjection(emotionalId)()?.title }}</div>
            } @empty {
              <div>No Objections</div>
            }
          </div>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label>
          <div class="horizontal">
            <div>Fact-based Objections</div>
            <a nz-button nzType="default" nzSize="small" (click)="onEditFactObjectionClick()">
              <span nz-icon style="font-size: 16px" class="material-symbols-rounded">edit</span>
            </a>
          </div>
        </nz-form-label>
        <nz-form-control>
          <div class="vertical">
            @for (factId of sessionTemplate?.unsafeSubData?.factObjectionIdList ?? []; track $index) {
              <div>- {{ getObjection(factId)()?.title }}</div>
            } @empty {
              <div>No Objections</div>
            }
          </div>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzRequired nzFor="salesCycle">Sales Cycle</nz-form-label>
        <nz-form-control nzErrorTip="Sales cycle required.">
          <nz-select formControlName="salesCycle" id="salesCycle" nzShowSearch nzAllowClear>
            @for (item of salesCycleList(); track $index) {
              <nz-option [nzValue]="item.id" [nzLabel]="item.title"></nz-option>
            }
          </nz-select>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzRequired nzFor="product">Product</nz-form-label>
        <nz-form-control nzErrorTip="Product required.">
          <nz-select formControlName="product" id="product" nzShowSearch nzAllowClear>
            @for (item of productList(); track $index) {
              <nz-option [nzValue]="item.id" [nzLabel]="item.title ?? ''"></nz-option>
            }
          </nz-select>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzRequired nzFor="resume">Customer</nz-form-label>
        <nz-form-control nzErrorTip="Resume required.">
          <nz-select formControlName="resume" id="resume" nzShowSearch nzAllowClear [nzSize]="'large'">
            @for (item of resumeList(); track $index) {
              <nz-option nzCustomContent [nzValue]="item.id" [nzLabel]="getResumeText(item)">
                <app-profile-card-small [resume]="item"></app-profile-card-small>
              </nz-option>
            }
          </nz-select>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzRequired nzFor="goal">Goal</nz-form-label>
        <nz-form-control nzErrorTip="Goal required.">
          <nz-select formControlName="goal" id="goal">
            @for (item of goalList(); track $index) {
              <nz-option [nzValue]="item.id" [nzLabel]="item.title"></nz-option>
            }
          </nz-select>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzRequired nzFor="methodology">Methodology</nz-form-label>
        <nz-form-control nzErrorTip="Methodology required.">
          <nz-select formControlName="methodology" id="methodology" nzShowSearch nzAllowClear [nzSize]="'large'">
            @for (item of methodologyList(); track $index) {
              <nz-option [nzValue]="item.id" [nzLabel]="item.title ?? ''"></nz-option>
            }
          </nz-select>
        </nz-form-control>
      </nz-form-item>
      <!-- 
      <nz-form-item>
        <nz-form-label nzRequired nzFor="methodology">Methodology</nz-form-label>
        <nz-form-control nzErrorTip="Methodology required.">
          <nz-select formControlName="methodology" id="methodology">
            @for (item of methodologyList(); track $index) {
              <nz-option [nzValue]="item.id" [nzLabel]="item.title ?? ''"></nz-option>
            }
          </nz-select>
        </nz-form-control>
      </nz-form-item> -->

      <!-- <nz-form-item>
        <nz-form-label nzRequired nzFor="language">Scenario Language</nz-form-label>
        <nz-form-control nzErrorTip="Language required.">
          <nz-select nzShowSearch formControlName="language" id="language">
            @for (item of languageList; track $index) {
              <nz-option [nzValue]="item.code" [nzLabel]="item.language"></nz-option>
            }
          </nz-select>
        </nz-form-control>
      </nz-form-item> -->

      <!-- <div class="horizontal">
        <nz-form-item>
          <nz-form-label nzRequired nzFor="creativity">
            <div class="horizontal">
              <div>Creativity</div>
              <app-question-button [text]="creativityExplain" [isMarkdown]="true"></app-question-button>
            </div>
          </nz-form-label>
          <nz-form-control nzErrorTip="Creativity required.">
            <nz-segmented
              class="fit-content"
              formControlName="creativity"
              id="creativity"
              [nzOptions]="creativityOptions"
            ></nz-segmented>
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label nzRequired nzFor="performance">
            <div class="horizontal">
              <div>Performance</div>
            </div>
          </nz-form-label>
          <nz-form-control nzErrorTip="Performance required.">
            <nz-segmented
              class="fit-content"
              formControlName="performance"
              id="performance"
              [nzOptions]="performanceOptions"
            ></nz-segmented>
          </nz-form-control>
        </nz-form-item>
      </div> -->

      <!-- <nz-form-item>
        <nz-form-label nzFor="additionalRubrics">Additional Rubrics</nz-form-label>
        <nz-form-control>
          <textarea
            formControlName="additionalRubrics"
            id="additionalRubrics"
            nz-input
            [nzAutosize]="{ minRows: 3, maxRows: 5 }"
          ></textarea>
        </nz-form-control>
      </nz-form-item> -->

      <!-- <nz-form-item>
        <nz-form-control>
          <button nz-button [nzType]="'primary'" class="submit-button">Create</button>
        </nz-form-control>
      </nz-form-item> -->
    </form>
  </ng-container>

  <div *nzModalFooter class="full-width horizontal seperate">
    <button
      nz-button
      nzType="default"
      [nzDanger]="true"
      nz-popconfirm
      nzPopconfirmTitle="Are you sure you want to delete?"
      nzPopconfirmPlacement="bottom"
      (nzOnConfirm)="onDeleteClick()"
    >
      Delete
    </button>

    <div class="horizontal">
      <button nz-button nzType="default" (click)="onCancelClick()">Cancel</button>
      <button nz-button nzType="primary" (click)="submitForm()">Save</button>
    </div>
  </div>
</nz-modal>

<app-edit-objection-list-session-template
  [(isVisible)]="isEditObjectionListVisible"
  [isEmotionalObjection]="isEmotionalObjection()"
  [sessionTemplate]="sessionTemplate!"
></app-edit-objection-list-session-template>
